// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_SortArray = require("rescript/lib/js/belt_SortArray.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var SearchInput$ReactHooksTemplate = require("../../common/SearchInput.res.js");
var ChannelBadge$ReactHooksTemplate = require("./ChannelBadge.res.js");
var TimelineEvent$ReactHooksTemplate = require("./TimelineEvent.res.js");

function Timeline(props) {
  var selectedEvent = props.selectedEvent;
  var onEventSelect = props.onEventSelect;
  var onChannelSelect = props.onChannelSelect;
  var setSearchFilter = props.setSearchFilter;
  var searchFilter = props.searchFilter;
  var activeChannel = props.activeChannel;
  var events = props.events;
  var filteredEvents = Belt_SortArray.stableSortBy(Belt_Array.keep(events, (function ($$event) {
              var searchText = ($$event.email + " " + $$event.phone + " " + $$event.desc).toLowerCase();
              var matchesSearch = searchText.includes(searchFilter.toLowerCase());
              if (activeChannel !== undefined) {
                if (matchesSearch) {
                  return $$event.source === activeChannel;
                } else {
                  return false;
                }
              } else {
                return matchesSearch;
              }
            })), (function (a, b) {
          var date1 = a.timestamp;
          var date2 = b.timestamp;
          var d1 = new Date(date1);
          var d2 = new Date(date2);
          if (Caml_obj.greaterthan(d1, d2)) {
            return -1;
          } else if (Caml_obj.lessthan(d1, d2)) {
            return 1;
          } else {
            return 0;
          }
        }));
  return JsxRuntime.jsxs("main", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("h2", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "h-8 mr-2",
                                      src: Image$ReactHooksTemplate.compass
                                    }),
                                "Customer Journey (Timeline)"
                              ],
                              className: "text-xl font-bold flex items-center flex-grow"
                            }),
                        JsxRuntime.jsx(SearchInput$ReactHooksTemplate.make, {
                              value: searchFilter,
                              onChange: Curry.__1(setSearchFilter)
                            })
                      ],
                      className: "mb-4 flex flex-wrap items-center gap-3"
                    }),
                JsxRuntime.jsx("div", {
                      children: Belt_Array.map(Belt_MapString.toArray(Belt_Array.reduce(events, undefined, (function (acc, $$event) {
                                      var count = Belt_Option.getWithDefault(Belt_MapString.get(acc, $$event.source), 0);
                                      return Belt_MapString.set(acc, $$event.source, count + 1 | 0);
                                    }))), (function (param) {
                              var source = param[0];
                              var isActive = Belt_Option.mapWithDefault(activeChannel, false, (function (ch) {
                                      return ch === source;
                                    }));
                              return JsxRuntime.jsx(ChannelBadge$ReactHooksTemplate.make, {
                                          source: source,
                                          count: param[1],
                                          isActive: isActive,
                                          onClick: (function (param) {
                                              if (isActive) {
                                                return Curry._1(onChannelSelect, undefined);
                                              } else {
                                                return Curry._1(onChannelSelect, source);
                                              }
                                            })
                                        }, source);
                            })),
                      className: "mb-4 flex flex-wrap items-center gap-3"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "absolute left-5 top-5 bottom-0 w-0.5 bg-gray-300 -ml-px"
                            }),
                        JsxRuntime.jsx("ol", {
                              children: Belt_Array.map(filteredEvents, (function ($$event) {
                                      return JsxRuntime.jsx(TimelineEvent$ReactHooksTemplate.make, {
                                                  event: $$event,
                                                  isSelected: selectedEvent !== undefined ? selectedEvent.timestamp === $$event.timestamp : false,
                                                  onSelect: onEventSelect
                                                }, $$event.timestamp);
                                    })),
                              className: "relative space-y-8"
                            })
                      ],
                      className: "overflow-auto max-h-64 relative pl-5"
                    })
              ],
              className: "flex-1 bg-gray-50 overflow-y-auto p-6 flex flex-col relative"
            });
}

var make = Timeline;

exports.make = make;
/* react/jsx-runtime Not a pure module */
